import { render, staticRenderFns } from "./PatientDetailsList.vue?vue&type=template&id=13c398fc&scoped=true"
import script from "./PatientDetailsList.vue?vue&type=script&lang=js"
export * from "./PatientDetailsList.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailsList.vue?vue&type=style&index=0&id=13c398fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c398fc",
  null
  
)

export default component.exports